import { createSlice } from "@reduxjs/toolkit";
import { status_slices } from "../../../../../config/constants";

export const reportsFinanceSlice = createSlice({
  name: "reportsFinance",
  initialState: {
    state: status_slices.WAITING,
    isLoading: false,
    msg: "",
    dateStart: "",
    dateEnd: "",
    rows: "0",
    ingresos: [],
    orders: [],
  },
  reducers: {
    processRequest: (state, action) => {
      state.isLoading = true;
      state.status = status_slices.PROCESSING;
    },
    notProcessRequest: (state, action) => {
      state.isLoading = false;
      state.status = status_slices.WAITING;
    },
    clearMemory: (state, action) => {
      state.isLoading = false;
      state.status = status_slices.WAITING;
      state.msg = "";
      state.dateStart = "";
      state.dateEnd = "";
      state.rows = "";
      state.ingresos = [];
      state.orders = [];
    },
    setListOrders: (state, action) => {
      state.isLoading = false;
      state.msg = action.payload.msg;
      state.rows = action.payload.rows;
      state.dateStart = action.payload.dateStart;
      state.dateEnd = action.payload.dateEnd;
      state.orders = action.payload.orders;
    },
    setIngresos: (state, action) => {
      state.isLoading = false;
      state.msg = action.payload.msg;
      state.dateStart = action.payload.dateStart;
      state.dateEnd = action.payload.dateEnd;
      state.ingresos = action.payload.ingresos;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.status = status_slices.NOT_LOADED;
      state.msg = action.payload.msg;
      state.dateStart = "";
      state.dateEnd = "";
      state.ingresos = [];
    },
  },
});

export const {
  processRequest,
  setListOrders,
  clearMemory,
  setError,
  setIngresos,
} = reportsFinanceSlice.actions;
